import i18n from '@shared/i18n';

export const panelBasePath = '/panel';

export const panelRouteMap = {
    home: {
        path: panelBasePath,
        routeName: 'home',
        localPageName: i18n.gettext('首頁'),
    },
    editor: {
        path: `${panelBasePath}/editor`,
        routeName: 'editor',
        localPageName: i18n.gettext('商店編輯器'),
    },
    order: {
        path: `${panelBasePath}/order`,
        routeName: 'order',
        localPageName: i18n.gettext('訂單管理'),
        routes: [
            {
                path: '/',
                routeName: 'order',
                localPageName: i18n.gettext('訂單列表'),
            },
        ],
    },
    product: {
        path: `${panelBasePath}/product`,
        routeName: 'product',
        localPageName: i18n.gettext('商品管理'),
        routes: [
            {
                path: '/',
                routeName: 'product',
                localPageName: i18n.gettext('所有商品'),
            },
            {
                path: '/category',
                routeName: 'category',
                localPageName: i18n.gettext('分類管理'),
            },
            {
                path: '/description',
                routeName: 'description',
                localPageName: i18n.gettext('商品共用段落'),
            },
        ],
    },
    member: {
        path: `${panelBasePath}/member`,
        routeName: 'member',
        localPageName: i18n.gettext('會員管理'),
        routes: [
            {
                path: '/',
                routeName: 'member',
                localPageName: i18n.gettext('會員列表'),
            },
        ],
    },
    promotions: {
        path: `${panelBasePath}/promotions`,
        routeName: 'promotions',
        localPageName: i18n.gettext('行銷工具'),
        routes: [
            {
                path: '/',
                routeName: 'promotions',
                localPageName: i18n.gettext('優惠活動總覽'),
            },
            {
                path: '/giveaway',
                routeName: 'giveaway',
                localPageName: i18n.gettext('加價購/贈品設定'),
            },
            {
                path: '/promo',
                routeName: 'promo',
                localPageName: i18n.gettext('優惠活動'),
            },
            {
                path: '/coupon',
                routeName: 'coupon',
                localPageName: i18n.gettext('優惠券設定'),
            },
        ],
    },
    revenue: {
        path: `${panelBasePath}/revenue`,
        routeName: 'revenue',
        localPageName: i18n.gettext('營收報表'),
        routes: [
            {
                path: '/',
                routeName: 'revenue',
                localPageName: i18n.gettext('營收狀況與報表'),
            },
        ],
    },
    settings: {
        path: `${panelBasePath}/settings`,
        routeName: 'settings',
        localPageName: i18n.gettext('品牌服務設定'),
        routes: [
            {
                path: '/brand',
                routeName: 'brand',
                localPageName: i18n.gettext('品牌基本資訊'),
            },
            {
                path: '/permission',
                routeName: 'permission',
                localPageName: i18n.gettext('管理員帳號設定'),
            },
            {
                path: '/basic',
                routeName: 'basic',
                localPageName: i18n.gettext('商店基礎設定'),
            },
            {
                path: '/finance',
                routeName: 'finance',
                localPageName: i18n.gettext('身份驗證與財務相關設定'),
            },
            {
                path: '/shipping',
                routeName: 'shipping',
                localPageName: i18n.gettext('運費設定'),
            },
            {
                path: '/navigation',
                routeName: 'navigation',
                localPageName: i18n.gettext('商店導覽選單設定'),
            },
        ],
    },
    extension: {
        path: `${panelBasePath}/extension`,
        routeName: 'extension',
        localPageName: i18n.gettext('擴充功能'),
        routes: [
            {
                path: '/advertisement',
                routeName: 'advertisement',
                localPageName: i18n.gettext('廣告目錄'),
            },
            {
                path: '/tracking',
                routeName: 'tracking',
                localPageName: i18n.gettext('第三方數據串接'),
            },
        ],
    },
    subscribe: {
        path: `${panelBasePath}/subscribe`,
        routeName: 'subscribe',
        localPageName: i18n.gettext('訂閱方案管理'),
        routes: [
            {
                path: '/plan',
                routeName: 'plan',
                localPageName: i18n.gettext('訂閱方案'),
            },
            {
                path: '/payment',
                routeName: 'payment',
                localPageName: i18n.gettext('帳單與付款資訊'),
            },
        ],
    },
    account: {
        path: `${panelBasePath}/account`,
        routeName: 'account',
        localPageName: i18n.gettext('我的帳號'),
        routes: [
            {
                path: '/profile',
                routeName: 'profile',
                localPageName: i18n.gettext('帳號設定'),
            },
        ],
    },
};
